<div class="container has-own-sub-chrome">
    <tam-workflow-config-sub-chrome [config]="workflowEditorSubChromeConfig">
    </tam-workflow-config-sub-chrome>
    <div class="view-box" *ngIf="showDiagram" (scroll)="onDiagramScroll($event)">
        <tam-diagram [config]="diagramConfig"></tam-diagram>
    </div>
</div>
<tam-context-menu [config]="contextMenuConfig"></tam-context-menu>